export default __webpack_public_path__ + "static/media/logo-csdg.ffb40adb.jpg";